import AnimatedSeparator from '../components/AnimatedSeparator';
import { Link } from 'react-router-dom';

export default function VisionPage() {
    return (
        <div className="page-container">
            <div className="container">

                {/* ── HERO ── */}
                <div className="row page-hero align-items-end">
                    <div className="col-md-7">
                        <h1>The Vision</h1>
                        <h2>an economic revolution, one idea at a time.</h2>
                    </div>
                </div>

                <AnimatedSeparator color="#f52e72" />

                {/* ── OPENING ARGUMENT ── */}
                <div className="row">
                    <div className="col-md-5">
                        <h3>
                            The startup world doesn't have a diversity problem.<br /><br />
                            It has a risk-design problem.<br /><br />
                            … and male-oriented VCs.
                        </h3>
                    </div>
                    <div className="col-md-6 offset-md-1">
                        <p>
                            The current model of building startups was designed around a specific kind of risk
                            tolerance — one that assumes you have savings to burn, a network to leverage, and
                            little to lose if it fails spectacularly.
                        </p>
                        <p>
                            Most women don't operate in those conditions. Not because they're less capable,
                            but because the conditions themselves were never designed for them.
                        </p>
                        <p>
                            The result: brilliant ideas don't get built. Capital concentrates. The same problems
                            get solved for the same people by the same founders.
                        </p>
                    </div>
                </div>

                <AnimatedSeparator color="#000" />

                {/* ── THE MATRIARCHY ── */}
                <div className="row">
                    <div className="col-md-3">
                        <h3 style={{ color: '#f52e72' }}>Building<br />the Matriarchy</h3>
                    </div>
                    <div className="col-md-8 offset-md-1">
                        <p>
                            The Matriarchy is not patriarchy-in-pink.
                        </p>
                        <p>
                            It's a people-centric economic model that puts the wellbeing of the next generation at the center of its design. 
                            It is a model that values sustainability over growth, and humanity over profit. 
                            It changes the way we think about risk, and the way we think about capital.
                        </p>
                        <p>
                            Our contribution is creating real opportunities for women to become foundresses, by removing risk from the earliest stage: the idea itself.
                            We provide professional support — not just guidance — to grow each idea into a profitable business within a year.
                        </p>
                        <p>
                            When investresses back these startups with even small cheques,
                            the compounding effect is enormous. €1,000 placed well at the right moment
                            is worth more than €100,000 placed blindly later — for both the investress and the foundress.
                        </p>
                    </div>
                </div>

                <AnimatedSeparator color="#f52e72" />

                {/* ── QUOTE ── */}
                <div className="row">
                    <div className="col-md-10">
                        <h3 className="quote">
                            "If every woman reading this would earn from her startup idea,
                            we could dismantle the [economic status quo] altogether in a decade."
                        </h3>
                        <p className="quote">— Ela Shapira</p>
                    </div>
                </div>

                <AnimatedSeparator color="#000" />

                {/* ── INVESTRESSES ── */}
                <div className="row">
                    <div className="col-md-3">
                        <h3>For<br />investresses</h3>
                    </div>
                    <div className="col-md-8 offset-md-1">
                        <p>
                            The Nursery is built to reduce risk for everyone — including the women who
                            back ideas with capital.
                        </p>
                        <p>
                            Every idea that reaches investment stage has already been reviewed, questioned,
                            and stress-tested. You're not betting on a pitch deck. You're evaluating something
                            that has already survived honest scrutiny.
                        </p>
                        <p>
                            Investress cheques start at €1,000. Larger investments (above €10,000) are
                            structured separately — reach out directly.
                        </p>
                        <ul className="custom-bullets-2" style={{ marginBottom: '2rem' }}>
                            <li>Reviewed ideas only — no raw pitches</li>
                            <li>Direct relationship with foundresses</li>
                            <li>Small entry point, meaningful stake</li>
                        </ul>
                        <p>
                            Interested in backing ideas through the Nursery?{' '}
                            <Link sx={{ cursor: "pointer" }}
                                onClick={() => window.location.href = `mailto:${'nursery'}@${'startup-doula.com'}`}>
                                Get in touch
                            </Link>.
                        </p>
                    </div>
                </div>

                <AnimatedSeparator color="#f52e72" />

                {/* ── CTA ── */}
                <div className="row">
                    <div className="col-md-8">
                        <h5>If you have an idea, this is where it starts to grow into a business.</h5>
                        <p style={{ marginBottom: '2rem' }}>
                            The Nursery is open. Submit your idea for review.
                        </p>
                        <Link to="/nursery" className="btn-primary">submit your idea</Link>
                    </div>
                </div>

            </div>
        </div>
    );
}
